import axios from "axios";

export const state = {
    members: [],
};

export const getters = {
    members: state => state.members,
};

export const mutations = {
    setMembers(state, newValue) {
        state.members = newValue
    },
};

export const actions = {
    async fetchMembers({ commit }) {
        await axios.get('/members').then(res => {
            commit('setMembers', res.data.members)
        })
    },
    async filterMembers({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filtermembers";
        await axios.post(url, formData).then((response) => {
            commit('setMembers', response.data.members)
        })
    },
};
